sharpen-alert {
  display: block;
  border-radius: var(--border-radius-md);
  padding: var(--spacing-md);
  display: flex;
  margin-bottom: var(--spacing-md);

  &[type="success"] {
    background-color: var(--color-light-green);
    a { color: var(--color-dark-green); }
  }

  &[type="warning"] {
    background-color: var(--color-light-orange);
    a { color: var(--color-dark-orange); }
  }

  &[type="danger"]  {
    background-color: var(--color-light-red);
    a { color: var(--color-dark-red); }
  }

  &[type="info"]    {
    background-color: var(--color-gray-4);
    a { color: var(--color-gray-1); }
  }


  .sharpen-alert--icon {
    padding-right: var(--spacing-md);
  }

  .sharpen-alert--heading {
    margin: 0;
    line-height: 1.1;
    font-weight: var(--font-weight-semibold);

    & + * {
      margin-top: var(--spacing-sm);
    }
  }

  .sharpen-alert--message {
    font-size: var(--font-size-xs);
    margin-top: var(--spacing-xxs);

    & > :last-child {
      margin-bottom: 0;
    }
  }
}